import { Link } from '@ipfabric/ui-components/Link/Link';
import { useLoadingState } from '@ipfabric/ui-components/hooks/useLoadingState';
import { useStableCallback } from '@ipfabric/ui-components/hooks/useStableCallback';
import { withLoadingIndicator } from '@ipfabric/ui-components/utils/loading/withLoadingIndicator';
import type { FC } from 'react';
import { useNotifications } from 'utils/hooks/useNotifications';
import { useApiScopeRequirementMet } from 'utils/permissions/useApiScopeRequirementMet';
import { useApi } from 'utils/request/useApi';

interface Props {
  serviceName: string;
  onServiceRestarted: () => void;
}

export const RestartService: FC<Props> = (props) => {
  const apiRequest = useApi().request;
  const [restarting, setRestarting] = useLoadingState();
  const apiScopeRequirementMet = useApiScopeRequirementMet();
  const notifications = useNotifications();

  const handleClick = useStableCallback(() =>
    withLoadingIndicator(setRestarting)(async () => {
      try {
        await apiRequest({
          url: '/os/restart-service',
          method: 'POST',
          data: { serviceName: props.serviceName },
        });
        notifications.showNotification({
          type: 'success',
          message: 'A restart of the service has been requested.',
        });
        props.onServiceRestarted();
      } catch (error) {
        notifications.showNotification({
          type: 'danger',
          message: 'The service failed to restart.',
        });

        throw error;
      }
    }),
  );

  if (
    !apiScopeRequirementMet({ method: 'POST', path: '/os/restart-service' })
  ) {
    return null;
  }

  return (
    <Link
      renderAs='button'
      onClick={handleClick}
      loading={restarting === 'LOADING'}
      size='small'
      type='button'
    >
      Restart
    </Link>
  );
};
